// import React, { useState, useEffect } from "react";
// import {
//   Modal,
//   Button,
//   Table,
//   Input,
//   Form,
//   Space,
//   message,
//   Spin,
//   notification,
// } from "antd";
// import { FaPlus, FaEdit, FaSearch } from "react-icons/fa";
// import { apiHandle } from "../../config/apiHandle";

// const SizeManagement = () => {
//   const [sizes, setSizes] = useState([]);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [editingSize, setEditingSize] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [form] = Form.useForm();
//   const [search, setSearch] = useState("");

//   useEffect(() => {
//     fetchSizes();
//   }, []);

//   // ✅ Fetch all sizes
//   const fetchSizes = async () => {
//     setLoading(true);
//     try {
//       const response = await apiHandle.get("admin/get-sizes");
//       setSizes(response?.data?.data || []);
//     } catch (error) {
//       message.error("Failed to fetch sizes.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Add or Update size
//   const handleAddOrUpdateSize = async () => {
//     try {
//       const values = await form.validateFields();
//       setLoading(true);

//       if (editingSize) {
//         await apiHandle.post(`admin/edit-Size/${editingSize._id}`, {
//           name: values.name,
//         });
//         notification.success({ message: "Size updated successfully" });
//       } else {
//         await apiHandle.post("admin/add-size", {
//           name: values.name,
//         });
//         message.success("Size added successfully");
//       }

//       fetchSizes();
//       form.resetFields();
//       setIsModalVisible(false);
//       setEditingSize(null);
//     } catch (error) {
//       notification.error({
//         message: "Please fill in all required fields correctly.",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Handle Edit Size
//   const handleEdit = (record) => {
//     setEditingSize(record);
//     form.setFieldsValue({
//       name: record.name,
//     });
//     setIsModalVisible(true);
//   };

//   // ✅ Filter Sizes for Search
//   const filteredSizes = sizes.filter((size) =>
//     size.name.toLowerCase().includes(search.toLowerCase())
//   );

//   // ✅ Table Columns
//   const columns = [
//     {
//       title: "Name",
//       key: "name",
//       dataIndex: "name",
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       render: (text, record) => (
//         <Space>
//           <Button icon={<FaEdit />} onClick={() => handleEdit(record)} />
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
//       <h1 className="text-3xl font-bold text-center mb-4">Size Management</h1>

//       {/* ✅ Search Bar */}
//       <div className="flex justify-between my-4">
//         <Input
//           placeholder="Search by size name"
//           prefix={<FaSearch />}
//           onChange={(e) => setSearch(e.target.value)}
//           style={{ width: "300px" }}
//         />
//         <Button
//           type="primary"
//           icon={<FaPlus />}
//           onClick={() => {
//             form.resetFields();
//             setIsModalVisible(true);
//           }}
//         >
//           Add Size
//         </Button>
//       </div>

//       {/* ✅ Table with Sizes */}
//       {loading ? (
//         <Spin size="large" className="flex justify-center" />
//       ) : (
//         <Table
//           columns={columns}
//           dataSource={filteredSizes}
//           pagination={{ pageSize: 15 }}
//           rowKey="_id"
//         />
//       )}

//       {/* ✅ Modal for Add & Edit */}
//       <Modal
//         title={editingSize ? "Edit Size" : "Add Size"}
//         visible={isModalVisible}
//         onCancel={() => {
//           setIsModalVisible(false);
//           setEditingSize(null);
//           form.resetFields();
//         }}
//         onOk={handleAddOrUpdateSize}
//         confirmLoading={loading}
//       >
//         <Form form={form} layout="vertical">
//           <Form.Item
//             name="name"
//             label="Size Name"
//             rules={[{ required: true, message: "Please enter a size name!" }]}
//           >
//             <Input />
//           </Form.Item>
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default SizeManagement;


import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Table,
  Input,
  Form,
  Space,
  message,
  Spin,
  notification,
  Select,
  Tag,
} from "antd";
import { FaPlus, FaEdit, FaSearch } from "react-icons/fa";
import { apiHandle } from "../../config/apiHandle";

const { Option } = Select;

const SizeManagement = () => {
  const [sizes, setSizes] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingSize, setEditingSize] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchSizes();
  }, []);

  // ✅ Fetch all sizes (with status)
  const fetchSizes = async () => {
    setLoading(true);
    try {
      const response = await apiHandle.get("admin/get-sizes");
      setSizes(response?.data?.data || []);
    } catch (error) {
      message.error("Failed to fetch sizes.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Add or Update size (with status)
  const handleAddOrUpdateSize = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (editingSize) {
        await apiHandle.post(`admin/edit-size/${editingSize._id}`, {
          name: values.name,
          status: values.status,
        });
        notification.success({ message: "Size updated successfully" });
      } else {
        await apiHandle.post("admin/add-size", {
          name: values.name,
          status: values.status || "Active", // Default status to Active
        });
        message.success("Size added successfully");
      }

      fetchSizes();
      form.resetFields();
      setIsModalVisible(false);
      setEditingSize(null);
    } catch (error) {
      notification.error({
        message: "Please fill in all required fields correctly.",
      });
    } finally {
      setLoading(false);
    }
  };

  // ✅ Handle Edit Size
  const handleEdit = (record) => {
    setEditingSize(record);
    form.setFieldsValue({
      name: record.name,
      status: record.status || "Active",
    });
    setIsModalVisible(true);
  };

  // ✅ Filter Sizes for Search
  const filteredSizes = sizes.filter((size) =>
    size.name.toLowerCase().includes(search.toLowerCase())
  );

  // ✅ Table Columns (With Status)
  const columns = [
    {
      title: "Size Name",
      key: "name",
      dataIndex: "name",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Space>
          <Button icon={<FaEdit />} onClick={() => handleEdit(record)} />
        </Space>
      ),
    },
  ];

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-center mb-4">Size Management</h1>

      {/* ✅ Search Bar */}
      <div className="flex justify-between my-4">
        <Input
          placeholder="Search by size name"
          prefix={<FaSearch />}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: "300px" }}
        />
        <Button
          type="primary"
          icon={<FaPlus />}
          onClick={() => {
            form.resetFields();
            form.setFieldsValue({ status: "Active" }); // Default status
            setIsModalVisible(true);
          }}
        >
          Add Size
        </Button>
      </div>

      {/* ✅ Table with Sizes & Status */}
      {loading ? (
        <Spin size="large" className="flex justify-center" />
      ) : (
        <Table
          columns={columns}
          dataSource={filteredSizes}
          pagination={{ pageSize: 15 }}
          rowKey="_id"
        />
      )}

      {/* ✅ Modal for Add & Edit */}
      <Modal
        title={editingSize ? "Edit Size" : "Add Size"}
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setEditingSize(null);
          form.resetFields();
        }}
        onOk={handleAddOrUpdateSize}
        confirmLoading={loading}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Size Name"
            rules={[{ required: true, message: "Please enter a size name!" }]}
          >
            <Input />
          </Form.Item>

          {/* ✅ Status Selection */}
          <Form.Item
            name="status"
            label="Status"
            rules={[{ required: true, message: "Please select status!" }]}
          >
            <Select>
              <Option value="Active">Active</Option>
              <Option value="Inactive">Inactive</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default SizeManagement;
